var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPt002ColorDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_983",
    "data-name": "Rectangle 983",
    width: 28.85,
    height: 29.014,
    fill: "#ee352e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "beginner_color_diamond",
    transform: "translate(-500 -808)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_987",
    "data-name": "Rectangle 987",
    transform: "translate(500 856) rotate(-45)",
    fill: "#fff1f0",
    stroke: "#ee352e",
    strokeLinejoin: "round",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.882,
    height: 67.882,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 59.882,
    height: 59.882,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1700",
    "data-name": "Group 1700",
    transform: "translate(523.672 832.042)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_984",
    "data-name": "Rectangle 984",
    width: 47.917,
    height: 47.917,
    transform: "translate(0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1699",
    "data-name": "Group 1699",
    transform: "translate(9.533 9.452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1698",
    "data-name": "Group 1698",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M28.852,28.429,25.358,14.394,28.486.366H23.205l-1.4,6.579H21.7A12.778,12.778,0,0,0,19.542,3.3,9.344,9.344,0,0,0,16.355.869,9.921,9.921,0,0,0,12.115,0,10.923,10.923,0,0,0,5.925,1.828,12.634,12.634,0,0,0,1.6,6.9,16.855,16.855,0,0,0,0,14.4a17.863,17.863,0,0,0,1.517,7.563A12.43,12.43,0,0,0,5.73,27.116a10.881,10.881,0,0,0,6.221,1.9,9.957,9.957,0,0,0,4.476-.914,9.583,9.583,0,0,0,3.26-2.566,13.4,13.4,0,0,0,2.146-3.718h.14l1.541,6.613ZM20.229,14.472a20.812,20.812,0,0,1-.886,2.9,15.507,15.507,0,0,1-1.507,2.959,8.2,8.2,0,0,1-2.2,2.284A5.029,5.029,0,0,1,12.7,23.5a4.913,4.913,0,0,1-3.25-1.178,7.619,7.619,0,0,1-2.182-3.254,13.287,13.287,0,0,1-.777-4.692,12.642,12.642,0,0,1,.8-4.64A7.305,7.305,0,0,1,9.529,6.569a5.413,5.413,0,0,1,3.45-1.142,5.163,5.163,0,0,1,2.995.859,7.335,7.335,0,0,1,2.08,2.22,14.5,14.5,0,0,1,1.37,2.9,22.947,22.947,0,0,1,.8,2.915l.016.068Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#ee352e"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt002ColorDiamond);
export default __webpack_public_path__ + "static/media/PT002_color_diamond.283af2199e55b8d0dbe8aecff04384a3.svg";
export { ForwardRef as ReactComponent };